import React, { useEffect } from 'react'
import { reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import PreliminaryBinocularForm from '../../../../itrust_common/components/authorised/examFormPartial/PreliminaryBinocularForm';

function ExamPreliminaryBinocularForm(props) {
  const { handleSubmit, template } = props;

  useEffect(() => {
    return () => {
      if (props.dirty) {
        handleSubmit();
      }
    }
  }, [props.dirty])

  return (
    <form onSubmit={handleSubmit}>
      <PreliminaryBinocularForm pprops={props} template={template} isTemplate={false} />
    </form>
  )
}

ExamPreliminaryBinocularForm = reduxForm({
  form: 'examPreliminaryBinocularForm',
  enableReinitialize: true,
})(ExamPreliminaryBinocularForm)

const mapStateToProps = state => {
  const { exam: { exam } } = state
  return {
    initialValues: {
      id: exam.id,
      priliminaries: exam.priliminaries,
      binocular: exam.binocular
    }
  }
}

export default connect(mapStateToProps)(ExamPreliminaryBinocularForm);